import { render, staticRenderFns } from "./CommentaAppList.vue?vue&type=template&id=8f8fd8e8&"
import script from "./CommentaAppList.vue?vue&type=script&lang=ts&"
export * from "./CommentaAppList.vue?vue&type=script&lang=ts&"
import style0 from "./CommentaAppList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports